export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8080'

/**
 * Fetch wrapper that prepends API_URL and includes credentials (cookies).
 * Drop-in replacement for fetch() when calling the Go API.
 */
export function apiFetch(path, options = {}) {
  return fetch(`${API_URL}${path}`, {
    ...options,
    credentials: 'include',
  })
}
